import styled from 'styled-components';

import { Flex } from '@/components/base';
import Button from '@/components/Button/Button';
import { getSourceIcon } from '@/types/feedbackConst';

export const SourceLabel = (props: FeedbackSourceT) => {
  return (
    <ButtonStyle
      variant="outlined"
      sizeType="s"
      className="size-6"
      $hasLink={!!props.link}
      onClick={() => {
        if (props.link) {
          window.open(props.link, '_blank');
        }
      }}
      tooltip={props.link ? 'Open source' : undefined}
    >
      <Flex a="center" j="center" className=" size-3.5">
        {getSourceIcon(props.type)}
      </Flex>
    </ButtonStyle>
  );
};

type ButtonStyleProps = {
  $hasLink: boolean;
};

const ButtonStyle = styled(Button)<ButtonStyleProps>`
  cursor: ${({ $hasLink }) => ($hasLink ? 'pointer' : 'default')};
  border-color: ${(props) => props.theme.colors.gray300};
  background-color: ${(props) => props.theme.colors.gray100};
  &:hover {
    border-color: ${(props) => props.theme.colors.gray400};
  }
`;
